import { cn } from '@/utils/cn'
import Image from 'next/image'
import { HTMLAttributes } from 'react'
interface SpinnerProps extends HTMLAttributes<HTMLDivElement> {
  size?: number
}

export const Spinner = ({ className, size = 32, ...props }: SpinnerProps) => {
  return (
    <div className={cn(className)} {...props}>
      <Image
        width={size}
        height={size}
        className="animate-spin"
        src={'/icons/spinner.png'}
        alt=""
      />
    </div>
  )
}
